export default "__VITE_ASSET__FWJuNktp__"